<div class="purple-fit-header-container {{showTabMenu?'tab-menu':''}}">
  <div class="purple-fit-header-container-internal">
    <div class="purple-fit-header-img-container">

      @if(layoutSvc.showHeaderIcon && breakSvc.breakPointDevice() != 'desktop'){
        <span (click)="layoutSvc.headerIconFunction()" class="purple-fit-header-img-icon {{layoutSvc.headerIconName}}"></span>
      }@else {
        @if(breakSvc.breakPointDevice() == 'desktop' || !showTabMenu){
          <img (click)="layoutSvc.headerIconFunction()" contentId="logo-header" contentTypeId="logo" purpleEditableImage
            class="purple-fit-header-img" />
        }
      }
    </div>
    @switch (breakSvc.breakPointDevice()) {
    @default {
    <div
      class="purple-fit-header-mobile-title-container ps-w-100 ps-d-flex ps-align-items-center ps-justify-content-center">
      <p class="purple-fit-header-mobile-title">{{layoutSvc.mobileTitle() | titlecase}}</p>
    </div>
    }
    @case ('desktop') {
    <ul class="purple-fit-header-menu-container" nz-menu nzMode="horizontal">
      @for (menuItem of layoutSvc.activeMenu; track $index) {
      @if (layoutSvc.showMenu(menuItem.maxLevel, menuItem.minLevel, menuItem.exlusiveRoles, menuItem.excludeRoles)) {
        @if(menuItem.click){
          <div (click)="menuItem.click()" 
        class="purple-fit-header-menu-button">
        <p class="purple-fit-menu-text">{{menuItem.name}}</p>

          </div>
        }@else{
<li nz-menu-item routerLinkActive="ant-menu-item-selected" [routerLink]="menuItem.relativeLink"
        [queryParams]="menuItem.queryParams" [nzSelected]="layoutSvc.checkIsCurrentMenu(menuItem.id)"
        class="purple-fit-header-menu-button">
        <p class="purple-fit-menu-text">{{menuItem.name}}</p>
      </li>
        }
      
      }

      }
      <li>
        <nz-select class="purple-fit-header-menu-language-select" [ngModel]="tsvc.currentLanguage()"
          (ngModelChange)="tsvc.switchLanguage($event)">
          @for (lan of tsvc.availableLanguages; track $index) {
          <nz-option [nzValue]="lan.languageId" [nzLabel]="lan.languageName.substring(0,3).toUpperCase()">
          </nz-option>
          }
        </nz-select>
      </li>
    </ul>
    }
    }
  </div>
</div>

@if ((breakSvc.breakPointDevice())=='mobile' && !showTabMenu) {
<div class="ps-d-flex ps-align-items-center ps-justify-content-end 
  purple-fit-header-mobile-hamburger-container {{menuOpen?'visible':''}}">
  <div (click)="hamburgerClick()" class="hamburger-button">
    <div class="hamburger-button-line" [@hamburguerX]="!menuOpen ? 'hamburguer' : 'topX'"></div>
    <div class="hamburger-button-line" [@hamburguerX]="!menuOpen ? 'hamburguer' : 'hide'"></div>
    <div class="hamburger-button-line" [@hamburguerX]="!menuOpen ? 'hamburguer' : 'bottomX'"></div>
  </div>
</div>
}


<nz-drawer nzWrapClassName="purple-fit-mobile-menu-drawer" [nzClosable]="false" [nzVisible]="menuOpen"
  nzPlacement="right" nzWidth="100%" nzHeight="100%">
  <ng-container *nzDrawerContent>
    <div class="purple-fit-mobile-menu-container {{mobileMenuClass}}">

      <ul nz-menu nzMode="vertical">
        @for (menuItem of layoutSvc.activeMenu; track $index) {
        @if(layoutSvc.showMenu(menuItem.maxLevel, menuItem.minLevel, menuItem.exlusiveRoles, menuItem.excludeRoles)){
        <li nz-menu-item routerLinkActive="ant-menu-item-selected" [routerLink]="menuItem.relativeLink"
          (click)="mobileNavigate()" [nzSelected]="layoutSvc.checkIsCurrentMenu(menuItem.id)"
          [queryParams]="menuItem.queryParams">
          <div class="purple-fit-mobile-menu-dot">
            <span class="purple-fit-mobile-menu-dot-icon {{menuItem.iconName}}"></span>
          </div>
          <p class="purple-fit-mobile-menu-text">{{menuItem.name}}</p>
        </li>
        }
        }
        <li class="purple-fit-mobile-menu-line"></li>
        <li class="switch-language-container">
          @for (lan of tsvc.availableLanguages; track $index) {
          <div (click)="switchLanguage(lan.languageId)"
            class="language-container {{isSelectedLanguage(lan.languageId)?'selected':''}}">
            <p class="language-name">{{getLanguageName(lan.languageName)}}</p>
            <div class="language-underline"></div>
          </div>
          }

        </li>
      </ul>
    </div>
  </ng-container>
</nz-drawer>